import cc from 'classcat';
import PropTypes from 'prop-types';
import { PureComponent, createRef } from 'react';

import { API_URL } from 'events/config';
import toGlobalID from 'events/utils/graphql/toGlobalID';
import Apple from '../icons/Apple';
import Button from '../Button';
import css from './index.module.scss';
import Google from '../icons/Google';
import Outlook from '../icons/Outlook';

class AddToCalendar extends PureComponent {
  constructor(props) {
    super(props);
    this.button = createRef(); // eslint-disable-line

    this.state = {
      adding: false,
      width: false,
    };
  }

  componentDidMount() {
    if (this.button.current === null) {
      return;
    }
    this.setState({ width: this.button.current.offsetWidth });
  }

  onClick = () => {
    this.setState({ adding: true });
  };

  render() {
    const { buttonProps, children, gcalUrl, id } = this.props;
    const { adding, width } = this.state;
    const textClass = cc([css.text, { [css.off]: adding, [css.on]: !adding }]);
    const messageClass = cc([css.text, css.message, { [css.on]: adding, [css.off]: !adding }]);
    const style = width ? { width } : {};
    const url = `${API_URL}events/${toGlobalID(id)}/export.ics`;

    return (
      <div className={cc([css.root, { [css.big]: buttonProps.big }])} style={style}>
        <div className={textClass} ref={this.button}>
          <Button onClick={this.onClick} {...buttonProps} tabIndex={adding ? -1 : 0}>
            {children}
          </Button>
        </div>
        <div className={messageClass}>
          <a
            className={css.button}
            href={gcalUrl}
            target="_blank"
            rel="noreferrer noopener"
            tabIndex={adding ? 0 : -1}
            title="Add to Google Calendar"
          >
            <Google />
          </a>
          <a className={css.button} href={url} tabIndex={adding ? 0 : -1} title="Add to iCal">
            <Apple />
          </a>
          <a className={css.button} href={url} tabIndex={adding ? 0 : -1} title="Add to Outlook">
            <Outlook />
          </a>
        </div>
      </div>
    );
  }
}
AddToCalendar.defaultProps = {
  buttonProps: {},
};
AddToCalendar.propTypes = {
  buttonProps: PropTypes.shape(),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  id: PropTypes.string.isRequired,
  gcalUrl: PropTypes.string.isRequired,
};

export default AddToCalendar;
